//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { ref } from '@vue/composition-api'

export default {
  setup() {
    const includeFiles = ref(true)
    const isInputEnabled = ref(false)

    return { includeFiles, isInputEnabled }
  },
}
